import React, { createContext, useState } from 'react';

export const ApplyContext = createContext();

export const ApplyProvider = ({ children }) => {
  const [isApplyModalOpen, setIsApplyModalOpen] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const [applicationData, setApplicationData] = useState({
    fullName: '',
    email: '',
    phone: '',
    coverLetter: '',
    resumeFileName: '',
    resumeFile: null
  });
  const [statusAlert, setStatusAlert] = useState({ type: '', message: '', link: '' });

  const openApplyModal = (job = null) => {
    setSelectedJob(job);
    setIsApplyModalOpen(true);
  };

  const closeApplyModal = () => {
    setIsApplyModalOpen(false);
    setSelectedJob(null);
    setApplicationData({
      fullName: '',
      email: '',
      phone: '',
      coverLetter: '',
      resumeFileName: '',
      resumeFile: null
    });
  };

  const handleApplicationChange = (field, value) => {
    setApplicationData(prev => ({ ...prev, [field]: value }));
  };

  const showStatusAlert = (type, message, link = '') => {
    setStatusAlert({ type, message, link });
    window.setTimeout(() => setStatusAlert({ type: '', message: '', link: '' }), 10000);
  };

  const value = {
    isApplyModalOpen,
    selectedJob,
    applicationData,
    statusAlert,
    openApplyModal,
    closeApplyModal,
    handleApplicationChange,
    setStatusAlert,
    showStatusAlert,
    setSelectedJob,
    setApplicationData
  };

  return (
    <ApplyContext.Provider value={value}>
      {children}
    </ApplyContext.Provider>
  );
};
